export default __webpack_public_path__ + "static/media/hero_1.09aaa69f.png";